export default function Django_Create_Database_In_RDS() {
  return <div>Django_Create_Database_In_RDS Component</div>;
}
